import React from "react";
import CampaignBuilder from "../../components/campaignBuilder/campaignBuilder";

const VortexEmail = () => {
  return <CampaignBuilder appName="vortex" />;
};

export default VortexEmail;
